'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import ScrollFloat from './ScrollFloat';

interface ImageTextProps {
  imageSrc: string;
  title: string;
  description?: string;
  imagePosition?: 'left' | 'right';
  altText?: string;
}

const ImageNextToText: React.FC<ImageTextProps> = ({ imageSrc, title, description, imagePosition = 'left', altText }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const isImageLeft = imagePosition === 'left';

  return (
    <div className="container mx-auto p-6">
      <div className={`flex flex-col md:flex-row items-center gap-8 max-w-4xl mx-auto ${isImageLeft ? '' : 'md:flex-row-reverse'}` }>
        <motion.img
          ref={ref}
          src={imageSrc}
          alt={altText ? altText : title}
          className="w-full md:w-1/2 rounded-3xl shadow-lg"
          initial={{ opacity: 0, x: 0, rotateY: 90, scale: 0.6 }}
          animate={isInView ? { opacity: 1, x: 0, rotateY: 0, scale: 1 } : {}}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        />
        <div className="w-full md:w-1/2">
          <ScrollFloat
            animationDuration={1}
            ease='back.inOut(2)'
            scrollStart='center bottom+=10%'
            scrollEnd='bottom bottom-=40%'
            stagger={0.05}
          >
          {title}
          </ScrollFloat>
          <p className="text-gray-400">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default ImageNextToText;
